import { Constants } from "./constants";

export function getImageUrl(name) {

const fileName = name.split(".")?.[0] || name;

return Constants.publicPath.productionServer + fileName;
}